import React from "react";
import Slider from "rc-slider";
import Tooltip from "rc-tooltip";
import withStyles from "react-jss";
import "rc-slider/assets/index.css";

const Handle = Slider.Handle;

const styles = {
  sliderWrapper: {
    width: "100%"
  },
  slider: {
    "& .rc-slider-track" : {
      // transition: "0.15s width"
    },
    "& .rc-slider-handle" : {
      border: "none",
      // transition: "0.15s left"
    },
    "& .rc-slider-handle:active" : {
      borderColor: "#b952d7",
      boxShadow: "0 0 5px #b952d7"
    }
  },
  handler: {
    zIndex: 1050
  }
};


const SliderHandler = ({ classes, value, dragging, index, ...restProps }) => (
  <Tooltip
    prefixCls="rc-slider-tooltip"
    overlayClassName={classes.handler}
    overlay={value}
    visible={dragging}
    placement="top"
    key={index}
    style={{
      zIndex: 1050
    }}
  >
    <Handle value={value} {...restProps} />
  </Tooltip>
);

const SliderHandlerWithStyles = withStyles(styles)(SliderHandler);

const Handler = props => <SliderHandlerWithStyles {...props} />;


const SliderField = ({classes, onChange, min, max, defaultValue, input, type, id, value}) => {
  let inputValue = input && input.value ? input.value : value ? value : defaultValue
  inputValue = parseInt(inputValue, 10)
  return (
    <div className={classes.sliderWrapper}>
      <Slider
        className={classes.slider}
        onChange={input ? input.onChange : onChange}
        min={min} 
        max={max} 
        defaultValue={defaultValue}
        handle={Handler}
        value={inputValue}
      />
      {input && <input 
        {...input}
        type={type} 
        id={id}
        style={{display: "none"}}
      /> }
      
    </div>
    
  );
};

export default withStyles(styles)(SliderField);